









































































































































































































































































































import Vue from 'vue';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default Vue.extend({
  name: 'Detail',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      unternehmen: {},
    };
  },
  mounted() {
    this.$store.dispatch('loadUnternehmenById', this.$route.params.id).then((results) => {
      this.unternehmen = results.data.message;
    });
  },
  methods: {
    imagepath: function(image: string) {
      return `${this.$store.state.imagedir}${image}`;
    },
    getBranche: function(id) {
      return this.$store.getters.getBranche(id);
    },
    getBundesland: function(id) {
      return this.$store.getters.getBundesland(id);
    },
    getBezirk: function(id) {
      return this.$store.getters.getBezirk(this.unternehmen.bundesland, id);
    },
    parseUrl: function(url) {
      let urls = url;
      if (url.includes(';')) {
        urls = url.split(';');
      }

      if (url.includes(',')) {
        urls = url.split(',');
      }
      if (Array.isArray(urls)) {
        return urls.map((item) => {
          if (!item.trim().startsWith('https://') && !item.trim().startsWith('http://')) {
            return `http://${item.trim()}`;
          } else {
            return item.trim();
          }
        });
      } else {
        if (!urls.trim().startsWith('https://') && !urls.trim().startsWith('http://')) {
          urls = `http://${urls}`;
        }
        return [].concat(urls);
      }
    },
  },
});
